import { csx } from '@vtex/admin-ui'

const styles = {
  alert: csx({
    marginTop: '$space-6',
    border: 'neutral',
    background: '$secondary',
    display: 'flex',
    alignItems: 'center',
    padding: '$space-4',
    gap: '$space-5',
    borderRadius: 4,
    '.icon': {
      minHeight: '2.5rem',
      minWidth: '2.5rem',
      background: '$gray20',
      borderRadius: 4,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      color: '$secondary',
    },
  }),
}

export default styles
